import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {GroupedData} from "../../data-structures/group"
import {SEPARATOR} from "../../gd-components/popover-menu/const"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldEventStatus from "../../fields3/system/event/status/status"
import FieldEventAssignedUser from "../../fields3/system/event/assigned-user/assigned-user"
import FieldEventParent from "../../fields3/system/event/parent/parent"
import FieldEventStartEnd from "../../fields3/system/event/start-end/start-end"
import FieldEventDurationWorkdays from "../../fields3/system/event/duration/duration-workdays"
import FieldEventDurationCalendar from "../../fields3/system/event/duration/duration-calendar"
import FieldEventStartDate from "../../fields3/system/event/start/start-date"
import FieldEventEndDate from "../../fields3/system/event/end/end-date"
import FieldPredecessors from "../../fields3/generic/dependency/predecessors/predecessors"
import FieldSuccessors from "../../fields3/generic/dependency/successors/dependants"
import FieldString from "../../fields3/generic/string/string"
import FieldText from "../../fields3/generic/text/text"
import FieldEventType from "../../fields3/system/event/type/type"
import FieldTemplateParent from "../../fields3/generic/template-parent/template-parent"
import FieldProjectPath from "../../fields3/generic/project-path/project-path"
import FieldConfig from "../../fields3/proto/field-config"
import FieldTaskTags from "../../fields3/system/task/tags/tags"
import FieldUser from "../../fields3/generic/user/user"
import {ColumnID} from "../../gd-modules/manager/columns/types"
import FieldProto from "../../fields3/proto/field-proto"

const baseConfig: FieldConfig[] = [
    {
        fieldId     : 'eventType',
        type        : FieldType.EVENT_TYPE
    },
    {
        fieldId     : 'name',
        type        : FieldType.STRING,
        label       : 'Name'
    },
    {
        fieldId     : 'userId',
        type        : FieldType.USER,
        label       : 'User',
    },
    {
        fieldId     : 'projectId',
        type        : FieldType.EVENT_PARENT
    },
    {
        fieldId     : 'projectPath',
        label       : 'Project path',
        type        : FieldType.PROJECT_PATH,
        maxParents  : 2
    },
    {
        fieldId     : 'tags',
        label       : 'Tags',
        type        : FieldType.TASK_TAGS
    },
    {
        fieldId     : 'templateParent',
        type        : FieldType.TEMPLATE_PARENT,
    },
    {
        fieldId     : 'startEnd',
        type        : FieldType.EVENT_START_END,
        clearButton : false
    },
    {
        fieldId     : 'startDate',
        type        : FieldType.EVENT_START,
        clearButton : false,
        label       : 'Start date'
    },
    {
        fieldId     : 'endDate',
        type        : FieldType.EVENT_END,
        clearButton : false,
        label       : 'End date'
    },
    {
        fieldId     : 'notes',
        type        : FieldType.TEXT
    },
    {
        fieldId     : 'isAccomplished',
        type        : FieldType.EVENT_STATUS
    },
    {
        fieldId     : 'assignedToUserId',
        type        : FieldType.EVENT_ASSIGNED_USER,
        // noValueOption: true - see field
    },
    {
        fieldId     : 'predecessors',
        type        : FieldType.PREDECESSORS,
        label       : 'Depends on',
    },
    {
        fieldId     : 'successors',
        type        : FieldType.SUCCESSORS,
        label       : 'Dependants'
    },
    {
        fieldId     : 'durationWorkdays',
        label       : 'Duration, workdays',
        type        : FieldType.PROJECT_DURATION_WORKDAYS,
    },
    {
        fieldId     : 'durationCalendar',
        label       : 'Duration, calendar',
        type        : FieldType.PROJECT_DURATION_CALENDAR,
    },
]

export default class EventFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.EVENT);

    }

    getByColumnId(columnId: ColumnID): FieldProto | undefined {
        /*const EventFieldsColumnToFieldMap: Record<SystemColumnType, FieldProto | undefined> = {
            [SystemColumnType.STATUS]: this.isAccomplished,
        }

        return EventFieldsColumnToFieldMap[columnId as SystemColumnType]*/
        return undefined
    }

    get eventType()         : FieldEventType { return this.get('eventType') as FieldEventType}
    get name()              : FieldString { return this.get('name') as FieldString}
    get startDate()         : FieldEventStartDate { return this.get('startDate') as FieldEventStartDate}
    get endDate()           : FieldEventEndDate { return this.get('endDate') as FieldEventEndDate}
    get startEnd()          : FieldEventStartEnd { return this.get('startEnd') as FieldEventStartEnd}
    get userId()            : FieldUser { return this.get('userId') as FieldUser}
    get projectId()         : FieldEventParent { return this.get('projectId') as FieldEventParent}
    get projectPath()       : FieldProjectPath { return this.get('projectPath') as FieldProjectPath}
    get tags()              : FieldTaskTags { return this.get('tags') as FieldTaskTags}
    get templateParent()    : FieldTemplateParent { return this.get('templateParent') as FieldTemplateParent}
    get assignedToUserId()  : FieldEventAssignedUser { return this.get('assignedToUserId') as FieldEventAssignedUser}
    get isAccomplished()    : FieldEventStatus { return this.get('isAccomplished') as FieldEventStatus}
    get predecessors()      : FieldPredecessors { return this.get('predecessors') as FieldPredecessors}
    get successors()        : FieldSuccessors { return this.get('successors') as FieldSuccessors}
    get durationWorkdays()  : FieldEventDurationWorkdays { return this.get('durationWorkdays') as FieldEventDurationWorkdays}
    get durationCalendar()  : FieldEventDurationCalendar { return this.get('durationCalendar') as FieldEventDurationCalendar}
    get notes()             : FieldText { return this.get('notes') as FieldText}

    get structureWidgetProperty():GroupedData {

        return [
            {
                value   : 'system',
                label   : 'System',
                type    : 'system',
                items   : [
                    this.startDate,
                    this.endDate,
                    this.startEnd,
                    SEPARATOR,
                    this.projectId,
                    this.assignedToUserId,
                ]
            }
        ]
    }

    get structureConditions():GroupedData {

        return [
            {
                value   : 'generic',
                label   : 'Generic',
                type    : 'system',
                items   : [
                    gd.fields.event.startDate,
                    gd.fields.event.endDate,
                    SEPARATOR,
                    gd.fields.event.isAccomplished,
                    SEPARATOR,
                    gd.fields.event.assignedToUserId,
                    gd.fields.event.userId,
                ]
            },
        ]
    }

    structureColorCoding():GroupedData {
        return [
            {
                value   : 'generic',
                label   : 'System fields',
                type    : 'system',
                items   : [
                    this.projectId,
                    this.isAccomplished,
                ]
            }
        ]
    }

    structureFilterFields(customFields?: any[]): GroupedData {
        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.name,
                    this.isAccomplished,
                    this.projectId,
                    // this.notes,
                ]
            },
            {
                value   : 'users',
                label   : 'Users',
                type    : 'system',
                items   : [
                    this.userId,
                    this.assignedToUserId,
                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items  : [
                    this.startDate,
                    this.endDate,
                    this.durationCalendar,
                    this.durationWorkdays,
                ]
            },
        ]
    }
}
